export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphMePeopleEndpoint: `https://graph.microsoft.com/v1.0/me/people`,
  graphUsersEndpoint: `https://graph.microsoft.com/v1.0/users`,
};
